import { withQualityFieldProfile } from "../qualityFieldProfile";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  Checkbox,
  Card,
  CardContent,
  Divider,
  FormControlLabel,
  IconButton,
  InputAdornment,
} from "@mui/material";
import SelectMultipleWidgetFilter from "components/SelectMultipleWidgetFilter";
import TextFieldWidgetText2 from "components/TextFieldWidget/TextFieldWidgetText2";
import {
  validateCleanAndFormatRut,
  validateRut,
} from "helpers/functionHelpers";
import { useCallback, useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import "../../../assets/scss/form.scss";
import viewsTexts from "../../../common/viewsTexts.json";
import {
  CardHeaderWidget,
  LoadingWidget,
  SaveAction,
} from "../../../components";
import { CloseButtonEditionArea } from "../../../components/EditionAreaWidget";
import { AxiosContext } from "../../../context/AxiosContext";
import { Context } from "../../../context/Context";
import {
  alphabeticalSort,
  alterArrayGetFields,
  formatRut,
} from "../../../helpers";
import { BsCol, BsRow } from "../../../layouts/components";
import { isGarcesFruitUser } from "../helperUsers";

const UserEdit = (props) => {
  const {
    id,
    email,
    name,
    lastname,
    phone,
    username,
    client,
    agrobusiness,
    rut,
    profile,
    whatsapp,
  } = props.rowEdit;

  const { editFunc, closeFunc } = props;
  const [profileDataState, setProfileDataState] = useState([]);
  const [clientDataState, setClientDataState] = useState([]);
  const [agroBusinessDataState, setAgroBusinessDataState] = useState([]);
  const [loadingDataState, setLoadingDataState] = useState(false);

  const { userId } = useContext(Context);
  const axiosContext = useContext(AxiosContext);

  const [showPassword, setShowPassword] = useState(false);

  const [loadingQueryState, setLoadingQueryState] = useState(false);
  const [successQueryState, setSuccessQueryState] = useState(false);

  const [hideClientDataState, setHideClientDataState] = useState(false);
  const [dataEditLoading, setDataEditLoading] = useState(false);

  const {
    handleSubmit,
    control,
    formState: { errors },
    register,
    getValues,
    reset,
    watch,
    setValue,
    setError,
    clearErrors,
  } = useForm();

  const watchClient = watch("client");
  const watchProfile = watch("profile");

  useEffect(() => {
    setDataEditLoading(true);

    if (profile && profile.value === "Administrador_Panel") {
      setHideClientDataState(true);
    } else {
      setHideClientDataState(false);
    }

    if (
      profileDataState &&
      profileDataState.length &&
      clientDataState &&
      clientDataState.length
    ) {
      reset({
        id: id || "",
        profile: profile || {},
        rut: rut || "",
        name: name || "",
        lastName: lastname || "",
        userName: username || "",
        email: email || "",
        phone: phone || "",
        client: profile.value !== "Administrador_Panel" ? client || {} : {},
        agroBusiness: agrobusiness || [],
        whatsapp: !!whatsapp,
      });
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [
    id,
    email,
    rut,
    name,
    lastname,
    username,
    agrobusiness,
    // maternalLastname,
    profile,
    phone,
    client,
    reset,
    profileDataState,
    clientDataState,
  ]);

  const rutValue = watch("rut");

  useEffect(() => {
    if (rutValue === undefined) return;
    if (!rutValue) {
      clearErrors("rut");
      return;
    }
    const formatted = validateCleanAndFormatRut(rutValue);
    if (rutValue !== formatted) {
      setValue("rut", formatted, { shouldValidate: true });
    }
    // Validar solo si hay valor y el rut es válido
    if (!validateRut(formatted)) {
      setError("rut", { type: "rutValido", message: "RUT inválido" });
    } else {
      clearErrors("rut");
    }
  }, [rutValue, setValue, setError, clearErrors]);

  useEffect(() => {
    if (watchClient) {
      const resultClient = clientDataState.filter(
        (ele) => ele.value === watchClient.value
      );
      // Actualizar la lista de agrícolas disponibles
      const newAgroBusinessData = alphabeticalSort(
        resultClient[0]?.agrobusiness,
        "label"
      );
      setAgroBusinessDataState(newAgroBusinessData);

      // Filtrar las agrícolas seleccionadas que pertenezcan solo al cliente actual
      const currentSelectedValues = getValues("agroBusiness") || [];
      const validAgroBusinessValues = currentSelectedValues.filter((dataAgro) =>
        newAgroBusinessData.some((item) => item.value === dataAgro.value)
      );

      // Actualizar el valor del formulario para mantener solo las agrícolas válidas
      setValue("agroBusiness", validAgroBusinessValues);
      setDataEditLoading(false);
    }
  }, [watchClient, clientDataState, setValue, getValues]);

  const onSubmit = async (values) => {
    // console.log(values, '<<---values')

    setLoadingQueryState(true);

    const profileSelected = profileDataState.filter(
      (ele) => ele.value === values.profile.value
    );
    // saca los objetos
    let clientObj = values.client
      ? clientDataState.filter((ele) => ele.value === values.client?.value)
      : null;

    clientObj = clientObj
      ? alterArrayGetFields(clientObj, ["id", "label", "value"])
      : null;

    // const agroBusinessObj = agroBusinessDataState.filter(
    // 	(ele) => ele.value === values.agroBusiness
    // );
    const agroBusinessArray = values.agroBusiness
      ? values.agroBusiness.reduce((acc, agro) => {
          const dataAgro = agroBusinessDataState.find(
            (item) => item.value === agro.value
          );
          if (dataAgro) {
            acc.push(dataAgro);
          }
          return acc;
        }, [])
      : [];

    if (values.rut) {
      if (!validateRut(values.rut)) {
        setError("rut", { type: "rutValido", message: "RUT inválido" });
        setLoadingQueryState(false);
        return;
      }
    }

    const query = {
      id: values.id,
      email: values.email,
      rut: values.rut ? formatRut(values.rut) : "",
      name: values.name,
      lastname: values.lastName,
      username: values.userName,
      // maternalLastname: values.maternalLastname,
      phone: values.phone,
      password: values.password || null,
      profile: profileSelected[0],
      agrobusiness: agroBusinessArray,
      client: clientObj ? clientObj[0] : null,
      whatsapp: !!values.whatsapp,
    };
    // console.log(query, '<<---query');

    try {
      const response = await axiosContext.authAxios.post(
        "v1/user/update-user",
        query
      );

      // console.log(response, '<---resp');

      if (response.status === 200) {
        // alert('listo');
        editFunc(response.data);
        setSuccessQueryState(true);
      }

      setLoadingQueryState(false);
    } catch (err) {
      setLoadingQueryState(false);
    }
  };

  const getProfilesAsync = useCallback(async () => {
    setLoadingDataState(true);
    try {
      let response = await axiosContext.authAxios.post(
        "v1/profile/list-profiles"
      );

      const { data, status } = response;

      if (status === 200) {
        let dataProfiles = alphabeticalSort(data.data, "label");

        dataProfiles = dataProfiles.map((profile) => {
          if (profile.value === "Administrador") {
            return {
              ...profile,
              label: `${profile.label} (JTP)`,
            };
          }
          return profile;
        });

        if (isGarcesFruitUser(userId)) {
          dataProfiles = dataProfiles.filter(
            (profile) => profile.value !== "Administrador_Panel"
          );
        }

        setProfileDataState(withQualityFieldProfile(dataProfiles));
      }
    } catch (error) {
      console.log(error);
      // setLoadingVarietyFilterState(false);
    } finally {
      setLoadingDataState(false);
    }
  }, [axiosContext, setLoadingDataState, setProfileDataState]);

  const getClientsAsync = useCallback(async () => {
    setLoadingDataState(true);
    try {
      let response = isGarcesFruitUser(userId)
        ? await axiosContext.authAxios.post("v1/client/list-clients", {
            value: "Garces_Fruit",
          })
        : await axiosContext.authAxios.post("v1/client/list-clients", {
            limit: 500,
          });

      const { data, status } = response;

      if (status === 200) {
        setClientDataState(alphabeticalSort(data.data, "label"));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingDataState(false);
    }
  }, [axiosContext, setLoadingDataState, setClientDataState]);

  // endpoints
  useEffect(() => {
    getProfilesAsync();
    getClientsAsync();
  }, []);

  // TOMA EL VALOR DE PASSWORD
  const { password } = getValues();

  useEffect(() => {
    if (watchProfile && watchProfile === "Administrador_Panel") {
      setHideClientDataState(true);
    } else {
      setHideClientDataState(false);
    }
  }, [watchProfile]);

  const onCloseSnack = () => {
    setSuccessQueryState(false);
    setDataEditLoading(false);
  };

  const handleClickShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <>
      {dataEditLoading ? (
        <LoadingWidget />
      ) : (
        <Card elevation={0}>
          <CardHeaderWidget
            title={
              viewsTexts.titles.user.userTextEdit + " " + name + " " + lastname
            }
          />
          <CloseButtonEditionArea closeFunc={props.closeFunc} />
          <Divider />
          <CardContent>
            <BsRow>
              <BsCol class="col-md-12">
                <form autoComplete="on" onSubmit={handleSubmit(onSubmit)}>
                  <BsRow>
                    <BsCol class="col-md-12">
                      <SelectMultipleWidgetFilter
                        options={profileDataState}
                        titleOption="label"
                        control={control}
                        name="profile"
                        labeltext="Perfil"
                        errors={errors.profile}
                        defaultValue=""
                        loading={loadingDataState}
                        req
                        withDefault
                        variant="outlined"
                        placeholder="Seleccione El Perfil"
                        display="vertical"
                        minheight={false}
                        isClearable={true}
                        isSearchable
                        sizeSelect={"large"}
                        isMulti={false}
                      />
                    </BsCol>
                  </BsRow>
                  {!hideClientDataState ? (
                    <BsRow class="mt-3">
                      <BsCol class="col-md-6">
                        <SelectMultipleWidgetFilter
                          options={clientDataState}
                          titleOption="label"
                          control={control}
                          name="client"
                          labeltext="Cliente"
                          errors={errors.client}
                          defaultValue=""
                          loading={loadingDataState}
                          req
                          withDefault
                          variant="outlined"
                          placeholder="Seleccione el Cliente"
                          display="vertical"
                          minheight={false}
                          isClearable={true}
                          isSearchable
                          sizeSelect={"large"}
                          isMulti={false}
                        />
                      </BsCol>
                      <BsCol class="col-md-6">
                        <SelectMultipleWidgetFilter
                          options={agroBusinessDataState}
                          titleOption="label"
                          control={control}
                          name="agroBusiness"
                          labeltext="Agrícola"
                          errors={errors.agroBusiness}
                          multiple={true}
                          defaultValue={[]}
                          loading={false}
                          req
                          withDefault
                          variant="outlined"
                          placeholder="Seleccione la Agrícola"
                          display="vertical"
                          minheight={false}
                          isClearable={true}
                          isSearchable
                          sizeSelect={"large"}
                          isMulti={true}
                        />
                      </BsCol>
                    </BsRow>
                  ) : null}
                  <BsRow class="mt-3">
                    <BsCol class="col-md-6">
                      <TextFieldWidgetText2
                        InputLabelProps={{ shrink: true }}
                        name="rut"
                        autoComplete="rut"
                        labeltext={viewsTexts.forms.rut}
                        control={control}
                        placeholder="11.111.111-1"
                        errors={errors.rut}
                        display="vertical"
                        defaultValue=""
                        req={false}
                      />
                      <TextFieldWidgetText2
                        display="vertical"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="id"
                        labeltext=""
                        control={control}
                        style={{
                          display: "none",
                        }}
                        defaultValue={id}
                      />
                    </BsCol>
                    <BsCol class="col-md-6">
                      <TextFieldWidgetText2
                        name="userName"
                        labeltext={viewsTexts.forms.userName}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        req={true}
                        defaultValue=""
                        minLength={3}
                        maxLength={12}
                        control={control}
                        errors={errors.userName}
                        autoComplete="username"
                        display="vertical"
                        type="text"
                      />
                    </BsCol>
                  </BsRow>
                  <BsRow class="mt-3">
                    <BsCol class="col-md-6">
                      <TextFieldWidgetText2
                        display="vertical"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="name"
                        labeltext={viewsTexts.forms.name}
                        req={false}
                        minLength={3}
                        maxLength={100}
                        control={control}
                        errors={errors.name}
                        autoComplete="given-name"
                        defaultValue=""
                      />
                    </BsCol>
                    <BsCol class="col-md-6">
                      <TextFieldWidgetText2
                        display="vertical"
                        name="lastName"
                        labeltext={viewsTexts.forms.lastName}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        req={false}
                        minLength={3}
                        maxLength={100}
                        control={control}
                        autoComplete="family-name"
                        errors={errors.lastName}
                        defaultValue=""
                      />
                    </BsCol>
                  </BsRow>
                  <BsRow class="mt-3">
                    <BsCol class="col-md-6">
                      <TextFieldWidgetText2
                        display="vertical"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="email"
                        labeltext={viewsTexts.forms.email}
                        req={false}
                        control={control}
                        errors={errors.email}
                        autoComplete="email"
                        defaultValue=""
                      />
                    </BsCol>
                    <BsCol class="col-md-6">
                      <TextFieldWidgetText2
                        display="vertical"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="phone"
                        type="number"
                        labeltext={viewsTexts.forms.phone}
                        req={false}
                        minLength={8}
                        maxLength={11}
                        control={control}
                        placeholder="56999999999"
                        autoComplete="phone"
                        errors={errors.phone}
                        defaultValue=""
                      />
                    </BsCol>
                  </BsRow>
                  <BsRow class="mt-3">
                    <BsCol class="col-md-6">
                      <TextFieldWidgetText2
                        display="vertical"
                        name="password"
                        type={showPassword ? "text" : "password"}
                        autoComplete="new-password"
                        minLength={6}
                        maxLength={12}
                        labeltext={viewsTexts.forms.password}
                        control={control}
                        errors={errors.password}
                        defaultValue=""
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                color="default"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                              >
                                {showPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </BsCol>
                    <BsCol class="col-md-6">
                      <TextFieldWidgetText2
                        display="vertical"
                        name="password2"
                        type={showPassword ? "text" : "password"}
                        equalto={password}
                        autoComplete="new-password"
                        minLength={6}
                        maxLength={12}
                        labeltext={viewsTexts.forms.password2}
                        control={control}
                        errors={errors.password2}
                        defaultValue=""
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                color="default"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                              >
                                {showPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </BsCol>
                  </BsRow>
                  <BsRow class="mt-2">
                    <BsCol class="col-md-12 text-center">
                      <Controller
                        name="whatsapp"
                        control={control}
                        defaultValue={false}
                        render={({ field }) => (
                          <FormControlLabel
                            label="Reportería"
                            control={
                              <Checkbox
                                color="primary"
                                checked={!!field.value}
                                onChange={(event) =>
                                  field.onChange(event.target.checked)
                                }
                              />
                            }
                          />
                        )}
                      />
                    </BsCol>
                  </BsRow>
                  <BsRow class="mt-5">
                    <BsCol class="col-md-12 text-center">
                      <SaveAction
                        title="Guardar"
                        color="secondary"
                        size="large"
                        className="roundedButton ml-md-2"
                        variant="contained"
                        disabled={loadingQueryState}
                        messageType="edit"
                        actionClose={() => {
                          closeFunc();
                          onCloseSnack();
                        }}
                        mutationLoading={loadingQueryState}
                        success={successQueryState}
                      />
                    </BsCol>
                  </BsRow>
                </form>
              </BsCol>
            </BsRow>
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default UserEdit;
